import React, { FC, useRef, useEffect, useState, useCallback } from 'react';
import _ from 'lodash';
import { flowMenuDataStore } from 'src/store/menu';
import { useLocation } from 'react-router-dom';
import TopLeftMiddleLayout from 'src/layout/TopLeftMiddleLayout';
import MainTopLeft from 'src/components/organisms/MainTopLeft';
import MainTop from 'src/components/organisms/MainTop';
import MainLeft from 'src/components/organisms/MainLeft';
import MotionPage from 'src/components/organisms/MotionPage';
import MainA from 'src/components/organisms/template/StepA';
import MainB from 'src/components/organisms/template/StepB';
import MainC from 'src/components/organisms/template/StepC';
import MainD from 'src/components/organisms/template/StepD';
import MainE from 'src/components/organisms/template/StepE';

import ModalContentLayout from 'src/components/organisms/modal/ModalContentLayout';
import ModalContentDep2Layout from 'src/components/organisms/modal/ModalContentDep2Layout';
import ModalConfirmLayout from 'src/components/organisms/modal/ModalConfirmLayout';
import ModalAlertLayout from 'src/components/organisms/modal/ModalAlertLayout';
import ModalErrorayout from 'src/components/organisms/modal/ModalErrorLayout';
import ModalHintLayout from 'src/components/organisms/modal/ModalHintLayout';
import LoadingLayout from 'src/components/atoms/LoadingLayout';
import './style.scss';

interface Props {}

const MainTemplate: FC<Props> = () => {
  // const flowMenuStore = flowMenuDataStore(state => state.data);
  // const flowMenu = flowMenuStore.page || [];
  const { state } = useLocation();
  const pageNum = state?.pageNum || 0;

  const middleContent = useCallback(() => {
    switch (pageNum) {
      case 0:
        return <MainA num={pageNum} />;
      case 1:
        return <MainB num={pageNum} />;
      case 2:
        return <MainC num={pageNum} />;
      case 3:
        return <MainD num={pageNum} />;
      case 4:
        return <MainE num={pageNum} />;
      default:
        return <div className="_no_temp">No Template</div>;
    }
  }, [pageNum]);

  return (
    <div className="_container">
      {/* <LeftMiddleLayout left={<MainTopLeft />} middle={middleContent()} /> */}
      <TopLeftMiddleLayout top={<MainTop />} left={<MainLeft />} middle={middleContent()} />
      <ModalAlertLayout />
      <ModalErrorayout />
      <ModalConfirmLayout />
      <ModalContentLayout />
      <ModalContentDep2Layout />
      <ModalHintLayout />
      <LoadingLayout />
    </div>
  );
};

export default MainTemplate;
